/**
 * Extract embed URL from YouTube or Vimeo links.
 * Returns null for unrecognised URLs so callers can fall back.
 */

export function getYouTubeId(url) {
  if (!url) return null;
  const match = url.match(
    /(?:youtube\.com\/(?:watch\?.*v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );
  return match ? match[1] : null;
}

export function getVimeoId(url) {
  if (!url) return null;
  const match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  return match ? match[1] : null;
}

/**
 * Given an arbitrary video URL, return an embeddable iframe src
 * with autoplay enabled, or null if the platform isn't recognised.
 */
export function getVideoEmbedUrl(url) {
  const ytId = getYouTubeId(url);
  if (ytId) {
    return `https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0`;
  }

  const vimeoId = getVimeoId(url);
  if (vimeoId) {
    return `https://player.vimeo.com/video/${vimeoId}?autoplay=1`;
  }

  return null;
}

/**
 * Return a thumbnail image URL for a YouTube or Vimeo video.
 * YouTube thumbnails are available at a deterministic URL.
 * Returns null for unrecognised platforms.
 */
export function getVideoThumbnailUrl(url) {
  const ytId = getYouTubeId(url);
  if (ytId) {
    // mqdefault = 320×180, good for small thumbnails
    return `https://img.youtube.com/vi/${ytId}/mqdefault.jpg`;
  }

  const vimeoId = getVimeoId(url);
  if (vimeoId) {
    // vumbnail.com is a free public proxy for Vimeo thumbnails
    return `https://vumbnail.com/${vimeoId}.jpg`;
  }

  return null;
}
